import {type ButtonProps} from './button.types'
import {StyledButton} from './button.styled'
import {getButtonStyleProps} from './utils'

export const Button = function Button({ref, ...props}: ButtonProps) {
    // Assign default value if not given
    const {children, ...rest} = props
    const propsWithDefaults = {
        ...rest,
        ...getButtonStyleProps(rest),
    }

    return (
        <StyledButton ref={ref} {...propsWithDefaults}>
            {children}
        </StyledButton>
    )
}
